export const messages = {
  item: {
    id: 'admin/promotions.form.utils.item-label',
  },
}
